import { HttpParams } from '@angular/common/http';
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Client } from '../../../../../projects/kiene-core/src/lib/components/client/classes/client';
import {
    ConfirmDialogInput,
    ConfirmDialogResult,
} from '../../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog';
import { ConfirmDialogComponent } from '../../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog.component';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { LocalStorageService } from '../../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { KieneUtils } from '../../../../../projects/kiene-core/src/lib/utils/KieneUtils';
import { CompanyGroup } from '../../../administration/company-group/company-group';
import {
    Behandlungsanfrage,
    BehandlungsanfragePosition,
} from '../../../documents/behandlungsanfrage/behandlungsanfrage';
import { Material } from '../../../warehouse/material/material';
import { ArticleScanAutocompleteComponent } from '../../article-scan-autocomplete/article-scan-autocomplete.component';
import { KieneTableService } from '../../kiene-table/kiene-table.service';
import { AddArticlePositionDialogComponent } from '../add-article-position-dialog/add-article-position-dialog.component';
import { CalendarWeek, KWDialogComponent } from '../kwdialog/kwdialog.component';
import {
    ArtikelMenge,
    buildTourenplanCommentOnlyPayload,
    isTourenplanCommentOnlyEdit,
    isValidTourenplanArtikelmenge,
    MAX_TOURENPLAN_ARTIKELMENGE,
    Tourenplan,
    tourenplanSaveStatusId,
} from '../tourenplan';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';

@Component({
    selector: 'kiene-edit-tour-page',
    templateUrl: './edit-tour-page.component.html',
    styleUrls: ['./edit-tour-page.component.scss'],
})
export class EditTourPageComponent implements OnInit {
    @ViewChild('articleAuto') articleAuto: ArticleScanAutocompleteComponent;
    @ViewChild('identifikation') identifikation: ElementRef;
    @ViewChild('menge') menge: ElementRef;

    behandlungsanfrageId: string;

    tour: Tourenplan = new Tourenplan();

    betriebe: Client[] = [];

    isKunde = true;

    paramsActive = new HttpParams().append('aktiv', '1');

    artikelMenge: ArtikelMenge[] = [];
    mengeCtrl = new UntypedFormControl();
    zieldatumFromCtrl = new UntypedFormControl(new Date());

    zieldatumToCtrl = new UntypedFormControl();
    currentCompanyGroup: CompanyGroup = new CompanyGroup();
    currentClient: Client; // = new Client();
    notizCtrl = new UntypedFormControl();
    apothekeCtrl = new UntypedFormControl(false);

    constructor(
        private readonly route: ActivatedRoute,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
        private readonly api: KieneTableService,
        private readonly session: LocalStorageService,
        public dialog: MatDialog,
        private readonly notification: MessageService,
        private readonly router: Router,
    ) {
        const id = this.route.snapshot.paramMap.get('id');
        if (id && id !== 'neu') {
            this.behandlungsanfrageId = id;
        }
    }

    ngOnInit() {
        this.initUserrole();
        if (this.behandlungsanfrageId) {
            this.loadTourenplan();
        }
    }

    goBack() {
        window.history.go(-1);
    }

    setClientAndCompanyGroup() {
        if (this.tour) {
            this.currentCompanyGroup = new CompanyGroup();
            this.currentCompanyGroup.bezeichnung = this.tour.unternehmensgruppe;
            this.currentCompanyGroup.unternehmensgruppe_id = this.tour.unternehmensgruppe_id;

            this.currentClient = new Client();
            this.currentClient.kunde_id = this.tour.kunde_id;
            this.currentClient.kunde_nr_intern = this.tour.kunde_nr_intern;
            this.currentClient.bezeichnung_final = this.tour.kunde;
            this.currentClient.zusatz_final = this.tour.zusatz;
        }
    }

    loadTourenplan() {
        this.api
            .getOne(this.apiBaseUrl + 'tourenplan_tierarzt/read_one.php', 'bestellung_id', this.behandlungsanfrageId)
            .subscribe(response => {
                this.tour = response;
                this.setArtikelMenge(this.tour);

                this.setClientAndCompanyGroup();

                this.zieldatumFromCtrl.setValue(this.tour.zieldatum);
                this.zieldatumToCtrl.setValue(this.tour.zieldatum_bis);

                this.apothekeCtrl.setValue(Number(this.tour.apotheke) === 1);

                this.notizCtrl.setValue(this.tour.bezeichnung);
            });
    }

    setArtikelMenge(b: Behandlungsanfrage) {
        if (b.positionen) {
            this.artikelMenge = [];
            for (const p of b.positionen) {
                const am = new ArtikelMenge();
                const m = new Material();
                m.artikel_me = p.artikel_me;
                m.artikel_id = p.artikel_id;
                am.article = m;
                am.menge = p.artikelmenge;
                am.anzahl_tiere = p.anzahl_tiere;
                am.identifikation = p.identifikation;
                am.ba_id = p.ba_id;
                this.artikelMenge.push(am);
            }
        }
    }

    initUserrole() {
        if (this.session.isCurrentUserKunde()) {
            this.isKunde = true;
            this.loadBetriebe();
        } else {
            this.isKunde = false;
        }
    }

    loadBetriebe() {
        if (this.isKunde) {
            this.api.get(this.apiBaseUrl + 'kunde/read.php', null).subscribe(response => {
                this.betriebe = response.records;
                if (this.betriebe.length === 1) {
                    this.currentClient = this.betriebe[0];
                }
            });
        }
    }

    setUnternehmensgruppe(companyGroup: CompanyGroup) {
        this.currentCompanyGroup = companyGroup;
    }

    save() {
        const invalid = this.artikelMenge.find(a => !isValidTourenplanArtikelmenge(a.menge));
        if (invalid) {
            this.notification.alertMessage(
                `Ungültige Menge bei „${invalid.article?.artikel_me || 'Artikel'}“ (max. ${MAX_TOURENPLAN_ARTIKELMENGE}).`,
            );
            return;
        }

        const isEdit = !!(this.tour && this.tour.bestellung_id);
        const kundeId =
            this.currentClient && this.currentClient.kunde_id ? this.currentClient.kunde_id : null;
        const ugId =
            this.currentCompanyGroup && this.currentCompanyGroup.unternehmensgruppe_id
                ? this.currentCompanyGroup.unternehmensgruppe_id
                : null;

        if (
            isTourenplanCommentOnlyEdit(
                this.tour,
                this.notizCtrl.value,
                this.zieldatumFromCtrl.value,
                this.zieldatumToCtrl.value,
                !!this.apothekeCtrl.value,
                this.artikelMenge,
                kundeId,
                ugId,
            )
        ) {
            this.api
                .updateEntity(
                    this.apiBaseUrl + 'behandlungsanfrage/update.php',
                    buildTourenplanCommentOnlyPayload(this.tour.bestellung_id, this.notizCtrl.value),
                )
                .subscribe(
                    () => {
                        this.notification.infoMessage('Die Anfrage wurde erfolgreich gespeichert!');
                        this.router.navigate(['startseite/tourenplan']);
                    },
                    error => {
                        this.notification.errorMessage('Die Tour konnte nicht gespeichert werden!', error);
                    },
                );
            return;
        }

        const b = new Behandlungsanfrage();
        // Full save (incl. Artikel): same as before – vet freigibt (3), Kunde aufgegeben (2).
        b.status_id = tourenplanSaveStatusId(this.isKunde);

        if (isEdit) {
            b.bestellung_id = this.tour.bestellung_id;
        }

        // kunde hat priorität gegenüber unternehmensgruppe
        if (kundeId) {
            b.kunde_id = kundeId;
        } else if (ugId) {
            b.unternehmensgruppe_id = ugId;
        }

        b.bezeichnung = this.notizCtrl.value;
        b.zieldatum = this.zieldatumFromCtrl.value;
        b.zieldatum_bis = this.zieldatumToCtrl.value;
        b.positionen = this.getPositionen();

        b.apotheke = this.apothekeCtrl.value ? 1 : 0;

        this.api.updateEntity(this.apiBaseUrl + 'behandlungsanfrage/update.php', b).subscribe(
            () => {
                this.notification.infoMessage('Die Anfrage wurde erfolgreich gespeichert!');
                this.router.navigate(['startseite/tourenplan']);
            },
            error => {
                this.notification.errorMessage('Die Tour konnte nicht gespeichert werden!', error);
            },
        );
    }

    getPositionen(): BehandlungsanfragePosition[] {
        const positionen: BehandlungsanfragePosition[] = [];

        for (const a of this.artikelMenge) {
            const b = new BehandlungsanfragePosition();
            b.artikel_id = a.article.artikel_id;
            b.artikelmenge = a.menge;
            b.identifikation = a.identifikation;
            b.anzahl_tiere = a.anzahl_tiere;
            b.ba_id = a.ba_id;
            positionen.push(b);
        }

        return positionen;
    }

    setClient(c: Client) {
        this.currentClient = c;
    }

    removeArtikel(am: ArtikelMenge) {
        const index = this.artikelMenge.indexOf(am);
        this.artikelMenge.splice(index, 1);
    }

    editArtikel(am: ArtikelMenge) {
        const dialogRef = this.dialog.open(AddArticlePositionDialogComponent, { data: am });
        dialogRef.afterClosed().subscribe({
            next: result => {
                if (result) {
                    am = result;
                }
            },
        });
    }

    openAddPositionDialog() {
        const dialogRef = this.dialog.open(AddArticlePositionDialogComponent, { width: '100%' });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.artikelMenge.push(result);
            }
        });
    }

    openSaveConfirmDialog() {
        const input = new ConfirmDialogInput();
        input.headline = this.behandlungsanfrageId ? 'Änderung speichern' : 'Bestellung abschließen';
        input.text = this.behandlungsanfrageId
            ? 'Die aktuellen Änderungen werden gespeichert'
            : 'Hiermit schließen Sie die aktuelle Bestellung ab!';

        const dialogRef = this.dialog.open(ConfirmDialogComponent, { width: '50%', minWidth: '300px', data: input });

        dialogRef.afterClosed().subscribe({
            next: (result: ConfirmDialogResult) => {
                if (result?.confirmed) {
                    this.save();
                }
            },
        });
    }

    openKWDialog() {
        const dialogRef = this.dialog.open(KWDialogComponent);
        dialogRef.afterClosed().subscribe({
            next: (kw: CalendarWeek) => {
                const monday = KieneUtils.getDateOfMonday(kw.weekNumber, kw.year);
                const sunday = KieneUtils.addDays(monday, 6);

                this.zieldatumFromCtrl.setValue(monday);
                this.zieldatumToCtrl.setValue(sunday);
            },
        });
    }
}
